import { useEffect, useState } from 'react'

const findScrollParent = (element) => {
  let parent = element.parentElement
  while (parent) {
    const overflowY = getComputedStyle(parent).overflowY
    if (overflowY === 'auto' || overflowY === 'scroll') return parent
    parent = parent.parentElement
  }
  return null
}

export function useIsHeaderPinnedToTop(ref) {
  const [isPinned, setIsPinned] = useState(false)

  useEffect(() => {
    const sentinel = ref.current
    if (!sentinel) return

    const scrollParent = findScrollParent(sentinel)
    const scrollTarget = scrollParent || window

    const update = () => {
      const sentinelTop = sentinel.getBoundingClientRect().top
      const containerTop = scrollParent ? scrollParent.getBoundingClientRect().top : 0
      setIsPinned(sentinelTop < containerTop)
    }

    update()
    scrollTarget.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    return () => {
      scrollTarget.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [ref])

  return isPinned
}
